<template>
    <div class="col-date">
        <div v-html="dateblock"></div>
    </div>
</template>

<script>

    let moment = require('moment');

    export default {
        name: "DatatableColDate",

        props: {
            data: {},
            name: {},
            click: {},
            meta: {},
            classes: {},
        },

        computed: {
            dateblock: function() {

                let string = '';

                string += '<div>'+moment.utc(this.data.start_date).format('MMM')+'<div>';
                string += '<div>'+moment.utc(this.data.start_date).format('D')+'-'+moment.utc(this.data.end_date).format('D')+'<div>';

                return string;
            }
        }
    }
</script>

<style scoped>

</style>
